<div class="pt-24 alert-dialog-modal">
	<h1 matDialogTitle class="alert-dialog-title ml-8">AVISO!</h1>
	<div mat-dialog-content>{{alertMessage}}</div>
	<div mat-dialog-actions class="pt-24 alert-dialog">
	    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(alert)">{{buttonMessage}}</button>
	</div>
</div>
    